import { PageView } from '@/components/layouts'
import PreSaleContract from '@/views/product-line-report/pre-sale-contract'
import DepositPurchase from '@/views/product-line-report/deposit-purchase'
import Overpurchase from '@/views/product-line-report/over-purchase'
import CreditPurchase from '@/views/product-line-report/credit-purchase'
import DeferredPayment from '@/views/product-line-report/deferred-payment'

export default {
  path: '/product-line-report',
  name: 'product-line-report',
  component: PageView,
  meta: { title: '产品线报表', keepAlive: false, icon: 'iconfont chanpinxianbaobiao' },
  children: [
    {
      path: '/product-line-report/pre-sale-contract',
      name: '/product-line-report/pre-sale-contract',
      component: PreSaleContract,
      meta: { title: '预售合同查询', keepAlive: false, icon: 'el-icon-star-on', action: [] },
    },
    {
      path: '/product-line-report/deposit-purchase',
      name: '/product-line-report/deposit-purchase',
      component: DepositPurchase,
      meta: { title: '定金采购查询', keepAlive: false, icon: 'el-icon-star-on', action: [] },
    },
    {
      path: '/product-line-report/over-purchase',
      name: '/product-line-report/over-purchase',
      component: Overpurchase,
      meta: { title: '超额采购查询', keepAlive: false, icon: 'el-icon-star-on', action: [] },
    },
    {
      path: '/product-line-report/credit-purchase',
      name: '/product-line-report/credit-purchase',
      component: CreditPurchase,
      meta: { title: '信用采购查询', keepAlive: false, icon: 'el-icon-star-on', action: [] },
    },
    {
      path: '/product-line-report/deferred-payment',
      name: '/product-line-report/deferred-payment',
      component: DeferredPayment,
      meta: { title: '延期支付查询', keepAlive: false, icon: 'el-icon-star-on', action: [] },
    }
  ]
}
